import { createFileRoute, redirect } from "@tanstack/react-router";

// Retired feature: send old links somewhere useful. Data is kept.
export const Route = createFileRoute("/refer-and-earn")({
  beforeLoad: () => {
    throw redirect({ to: "/learning-journeys", replace: true, statusCode: 301 });
  },
});
